import React from 'react'
import _ from 'lodash'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { compose, bindActionCreators } from 'redux'
import { t } from 'i18next'

import withReduxModal, {
  modalPropTypes,
} from '../../../modules/redux-modal/redux/withReduxModal'
import SortableComponent, {
  createSortableItem,
} from '../../views/widgets/SortableComponent'
import ImagePreview from '../image-preview/ImagePreview'
import { PORTAL_LINK_IMAGE_FORM_MODAL } from '../../../constants/modalType'
import { removeLinkImage, updateLinkImages } from '../../../actions/portal'
import ImageEmptySection from '../image-management/ImageEmptySection'
import TruncateWidth from '../../views/widgets/TruncateWidth'

class PortalLinkImage extends React.Component {
  static propTypes = {
    ...modalPropTypes,
    links: PropTypes.array.isRequired,
  }

  handleLinkImageRemove = imageID => {
    if (window.confirm(t('alert.deleteImage.label'))) {
      this.props.actions.removeLinkImage(imageID)
    }
  }

  showLinkImageFormModal = imageID => {
    const link = _.find(this.props.links, { mainImageId: imageID })

    this.props.modalActions.showModal(PORTAL_LINK_IMAGE_FORM_MODAL, { link })
  }

  handleSortEnd = links => {
    this.props.actions.updateLinkImages(links)
  }

  render() {
    if (_.isEmpty(this.props.links)) {
      return <ImageEmptySection />
    }

    return (
      <SortableComponent
        axis="x"
        items={this.props.links}
        onSortEnd={this.handleSortEnd}
        renderSortableItem={({ item, ...props }) => (
          <SortableItem
            key={item.mainImageId}
            item={item}
            language={this.props.language}
            {...props}
            onImageSelect={this.showLinkImageFormModal}
            onImageRemove={this.handleLinkImageRemove}
          />
        )}
      />
    )
  }
}

export default compose(
  withReduxModal,
  connect(
    ({ portal, info }) => ({
      links: portal.links || [],
      language: info.language,
    }),
    dispatch => ({
      actions: bindActionCreators(
        {
          removeLinkImage: removeLinkImage,
          updateLinkImages: updateLinkImages,
        },
        dispatch,
      ),
    }),
  ),
)(PortalLinkImage)

const PortalLinkImageItem = ({
  item,
  onImageSelect,
  onImageRemove,
  language = 'th',
}) => {
  const imageID = _.get(item, 'mainImageId')
  const lastChecked = _.get(item, 'lastChecked')
  const title = _.get(item, `title.${language}`)
  const externalURL = _.get(item, 'externalUrl')
  return (
    <div key={imageID} onClick={() => onImageSelect(imageID)}>
      <ImagePreview
        imageID={imageID}
        lastChecked={lastChecked}
        onImageSelect={onImageSelect}
        onImageRemove={onImageRemove}
      />
      <hr style={{ margin: '4px' }} />
      <div style={{ padding: '4px' }}>
        <TruncateWidth width={180}>
          <strong>
            <i className="fas fa-heading" /> {title || 'N/A'}
          </strong>
          <p>
            <small>
              <i className="fas fa-link" /> {externalURL || 'N/A'}
            </small>
          </p>
        </TruncateWidth>
      </div>
      <div style={{ padding: 4 }}>
        <a className="button is-default is-small is-fullwidth">
          เพิ่ม/แก้ไข ข้อมูล
        </a>
      </div>
    </div>
  )
}

const SortableItem = createSortableItem(PortalLinkImageItem)



// WEBPACK FOOTER //
// ./src/components/templates/portal-link/PortalLinkImage.js